'use client';
import React, { useState } from 'react';
import { YStack } from 'tamagui'; // Replace with actual import

const CustomPressable = ({ children, style, activeOpacity = 0.2, ...props }) => {
  const [isPressed, setIsPressed] = useState(false);

  const handlePressIn = () => {
    setIsPressed(true);
  };

  const handlePressOut = () => {
    setIsPressed(false);
  };

  const combinedStyle = [
    style,
    isPressed && { opacity: activeOpacity }
  ];

  return (
    <YStack
      {...props}
      style={combinedStyle}
      onMouseDown={handlePressIn}
      onMouseUp={handlePressOut}
      onMouseLeave={handlePressOut}
      onTouchStart={handlePressIn}
      onTouchEnd={handlePressOut}
    >
      {children}
    </YStack>
  );
};

export default CustomPressable;
